import React from 'react';

const PathActions = ({ 
  resetAllPaths, 
  confirmAllPaths, 
  vehiclePaths, 
  locations
}) => {
  const isAllPathsEmpty = vehiclePaths.every(vehicle => vehicle.path.length <= 1);
  
  const isAllPointsAssigned = locations.every(loc => 
    vehiclePaths.some(vehicle => 
      vehicle.path.some(point => point && point.id === loc.id)
    )
  );
  
  const hasEmptyPaths = vehiclePaths.some(vehicle => vehicle.path.length === 0);
  
  return (
    <div className="custom-path-actions">
      <button 
        className="reset-path-btn"
        onClick={resetAllPaths}
        disabled={isAllPathsEmpty}
      >
        Reset all paths
      </button>
      
      <button 
        className="confirm-path-btn"
        onClick={confirmAllPaths}
        disabled={hasEmptyPaths || !isAllPointsAssigned}
      >
        Confirm all paths
      </button>
    </div>
  );
};

export default PathActions; 